import {
  parseCurrencyToNumber,
  safeNumber,
} from "./formHelpers";

/** Redux field error helper for guardians[i].storageKey */
export function fieldError(errors, index, storageKey) {
  return errors?.[`guardians.${index}.${storageKey}`];
}

export function showHighBondSsn(cfg, globalData) {
  const amt = safeNumber(
    parseCurrencyToNumber(globalData?.basicInformation?.bondAmount)
  );
  if (cfg.bondAmountSsnOp === "gt") return amt > cfg.bondAmountSsnThreshold;
  return amt >= cfg.bondAmountSsnThreshold;
}

export function showManualOccupation(cfg, globalData, guardian) {
  if (!cfg.showManualOccupation || cfg.manualOccupationWhen === "never") {
    return false;
  }
  if (cfg.manualOccupationWhen === "always") return true;
  return (
    showHighBondSsn(cfg, globalData) &&
    guardian.is_professional_guardian !== "Yes" &&
    guardian.is_attorney !== "Yes"
  );
}

export function showRelationship(cfg, guardian) {
  if (cfg.relationshipShowWhen === "notPg") {
    return guardian.is_professional_guardian !== "Yes";
  }
  return (
    guardian.is_professional_guardian !== "Yes" &&
    guardian.is_attorney !== "Yes"
  );
}

/**
 * Email block visibility for bond principal manual row.
 */
export function getPrincipalEmailVisibility(cfg, guardian, globalData) {
  const showGlobalEsign = globalData?.basicInformation?.is_esignatures === "Yes";
  const showPrincipalEsign = guardian.is_esignatures_principal === "Yes";

  if (
    cfg.emailUi === "newPgOrGlobalEsign" ||
    cfg.emailUi === "newPgOrGlobalEsignWithNote"
  ) {
    return guardian.is_new_pg || showGlobalEsign;
  }
  if (cfg.emailUi === "newPgOrPrincipalEsignWithNote") {
    return guardian.is_new_pg || showPrincipalEsign;
  }
  return false;
}

export function principalEmailShowsNoteBanner(cfg) {
  return (
    cfg.emailUi === "newPgOrGlobalEsignWithNote" ||
    cfg.emailUi === "newPgOrPrincipalEsignWithNote"
  );
}

/** E-signatures flag aligned with probate/trustee/VA (`global`) vs guardianship (`principal`). */
export function principalEmailBannerEsignFlag(cfg, guardian, globalData) {
  if (cfg.emailUi === "newPgOrPrincipalEsignWithNote") {
    return guardian.is_esignatures_principal === "Yes";
  }
  return globalData?.basicInformation?.is_esignatures === "Yes";
}
